module.exports = __webpack_public_path__ + "img/27.b8c79dcf.jpg";